<template>
  <div>
    <el-dialog title="文生图" :visible.sync="dialogFormVisible" width="600px" top="30px" :close-on-click-modal="false"
      @close="emitClose" @open="open()">
      <div class="contents">
        <div class="contentTop">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="inputText" style="width:321px">
          </el-input>
          <div class="buttons" @click="handlePhoto()">生成图片</div>
        </div>
        <div class="contentBottom">
          <div class="bottomLeft">
            <img :src="pictureList[active]" v-if="pictureList.length > 0" />
          </div>
          <div class="bottomRight">
            <p>选择模板</p>
            <div class="chooseImg" v-if="pictureList.length > 0">
              <img :src="item" v-for="(item, index) in pictureList" :key="index" :class="{ 'active': index == active }"
                @click="handleChoose(index)" />

            </div>
          </div>
          <PhotofuniaVue :inputText="inputText" :startInit="startInit" :list="list" @ondrawed="ondrawed"
            @ondraw="ondraw" :startGenerating="startGenerating" />
        </div>
        <div class="percentags" v-if="isGerate">
          <el-progress type="circle" :percentage="percentage" width="50" stroke-width="3"
            text-color="#fff"></el-progress>
          <div style="marginTop:10px;width:200px">图片生成中....</div>
        </div>
        <div class="footer">

          <div class="cancle" @click="handleCancle()">取消</div>
          <div class="confirm" @click="handleConfirm()">确定</div>
        </div>
      </div>

    </el-dialog>

  </div>
</template>
<script>
import PhotofuniaVue from '../../Photofunia/Photofunia.vue'
export default {
  components: { PhotofuniaVue },
  data() {
    return {
      percentage: 0,
      isGerate: false,
      pictureList: [],
      dialogFormVisible: this.isVisible,
      textarea: '',
      inputText: '',
      startInit: false,
      startGenerating: false,
      progress: 0,
      active: 0,
      list: [
        {
          url: require('/src/assets/img/moular1.png'),
          x1: 30,
          y1: 80,
          x2: 320,
          y2: 400,
          maxFontSize: 60,
          minFontSize: 16,
          debug: false,
          options: {
            lineHeight: 1.6,
            letterSpacing: 3,
            color: '#323233',
            fontWeight: 'bold',
            padding: 10,
            fontFamily: 'AlimamaShuHeiTi',
            aline: 'center',
            distance: 40,
          },
        },
        {
          url: require('/src/assets/img/moular2.png'),
          x1: 30,
          y1: 70,
          x2: 270,
          y2: 350,
          maxFontSize: 60,
          minFontSize: 18,
          debug: false,
          options: {
            lineHeight: 1.6, // 行高为字体大小的1.6倍
            letterSpacing: 4, // 1px字间距
            color: '#323233', // 蓝色文字
            fontWeight: 400, // 粗体
            padding: 10, // 10rpx内边距}
            fontFamily: 'SanJiXingKaiJianTi',
            aline: 'left',
            distance: 40,
          },
        },
        {
          url: require('/src/assets/img/moular3.png'),
          x1: 40,
          y1: 80,
          x2: 320,
          y2: 400,
          maxFontSize: 48,
          minFontSize: 18,
          debug: false,
          options: {
            lineHeight: 1.6, // 行高为字体大小的1.6倍
            letterSpacing: 2, // 1px字间距
            color: '#323233', // 蓝色文字
            fontWeight: '400', // 粗体
            padding: 10, // 10rpx内边距}
            fontFamily: 'YouSheBiaoTiHei',
            aline: 'left',
            distance: 80,
          },
        },
        {
          url: require('/src/assets/img/moular5.png'),
          x1: 40,
          y1: 100,
          x2: 300,
          y2: 350,
          maxFontSize: 60,
          minFontSize: 18,
          debug: false,
          options: {
            lineHeight: 1.6, // 行高为字体大小的1.6倍
            letterSpacing: 3, // 1px字间距
            color: '#323233', // 蓝色文字
            fontWeight: '400', // 粗体
            padding: 10, // 10rpx内边距}
            fontFamily: 'SanJiXingKaiJianTi',
            aline: 'center',
            distance: 80,
          },
        },
        {
          url: require('/src/assets/img/moular4.png'),
          x1: 40,
          y1: 120,
          x2: 300,
          y2: 320,
          maxFontSize: 60,
          minFontSize: 18,
          debug: false,
          options: {
            lineHeight: 1.6, // 行高为字体大小的1.6倍
            letterSpacing: 1, // 1px字间距
            color: '#323233', // 蓝色文字
            fontWeight: '400', // 粗体
            padding: 10, // 10rpx内边距}
            fontFamily: 'AlimamaShuHeiTi',
            aline: 'center',
            distance: 80,
          },
        },
      ],
    }
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    curritem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
    curritem: {
      handler(val) {
        this.updateInputText()
      },
      deep: true,      // 深度监听对象内部值的变化
      immediate: true  // 组件创建时立即执行一次
    }

  },
  methods: {
    updateInputText(){
      if (this.curritem) {
        this.inputText = `${this.curritem.topic_college_name}\n(${this.curritem.topic_major_code})${this.curritem.topic_major_name}\n${this.curritem.question_name}`;
      }
    },
    handleCancle() {
      this.active = 0
      this.dialogFormVisible = false
    },
    handleConfirm() {
      if (this.pictureList.length == 0) {
        this.$message.error(`请选择图片`)
        return
      }
      this.$emit('choosePicture', this.pictureList[this.active])
      this.handleCancle()
    },
    open() {
      this.startInit = true
    },
    handlePhoto() {
      if (this.inputText == '') {
        this.$message.error(`请输入内容`)
        return
      }
      this.startGenerating = true
      this.isGerate = true
    },
    emitClose() {
      this.pictureList = []
      // this.inputText=''
      this.$emit('close')
      this.startGenerating = false
      this.isGerate=false
      this.progress=0
    },
    ondrawed(e) {
      this.pictureList = e.picture
    },
    ondraw(e) {
      console.log('生成图片进度',e)
      this.progress = e.progress + this.progress
      this.percentage = this.progress / 5

      if (this.progress == 500) {
        this.isGerate = false
        this.percentage = 0
      }
    },
    handleChoose(index) {
      this.active = index
    },
  },
}
</script>
<style lang="less" scoped>
.contents {
  padding-bottom: 60px;
  position: relative;

  .contentTop {
    display: flex;
    align-items: center;

    .buttons {
      border: 1px solid #409eff;
      cursor: pointer;
      margin-left: 10px;
      text-align: center;
      width: 66px;
      height: 30px;
      text-align: center;
      line-height: 26px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #409eff;

      border-radius: 4px 4px 4px 4px;
    }
  }

  .contentBottom {
    margin-top: 30px;
    display: flex;

    .bottomLeft {
      width: 349px;
      height: 300px;
      background: #e8e8e8;
      border-radius: 4px 4px 4px 4px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .bottomRight {
      width: 400px;
      font-weight: 700;
      margin-left: 10px;

      .chooseImg {
        margin-top: 10px;
        width: 330px;
        height: 200px;

        display: flex;
        flex-wrap: wrap;

        .active {
          border: 1px solid #409eff;
        }

        img {
          margin-right: 15px;
          width: 46px;
          height: 64px;
          background: #e8e8e8;
          border-radius: 4px 4px 4px 4px;
        }
      }
    }
  }

  .percentags {
    padding: 20px 40px;
    position: absolute;
    font-size: 10px;
    left: 40%;
    top: 130px;
    width: 130px;
    height: 130px;
    background: rgba(0, 0, 0, 0.9);
    opacity: 0.9;
    border-radius: 16px;
  }

  .footer {
    display: flex;
    justify-content: flex-end;

    .cancle {
      text-align: center;
      width: 56px;
      height: 36px;
      line-height: 36px;
      font-weight: 400;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdfe6;
      font-size: 14px;
      margin-right: 10px;
    }

    .confirm {
      text-align: center;
      width: 56px;
      height: 36px;
      color: #fff;
      line-height: 36px;
      background: #409eff;
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
    }
  }
}
</style>